var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
export class ApprovalModel {
    constructor(approval) {
        if (approval) {
            Object.assign(this.approval, approval);
        }
    }
    toJson() {
        return {
            id: this.approval.id,
            orderId: this.approval.orderId,
            text: this.approval.text,
            actions: this.approval.actions
        };
    }
}
__decorate([
    observable
], ApprovalModel.prototype, "approval", void 0);
__decorate([
    action
], ApprovalModel.prototype, "toJson", null);
